import React from 'react';
import { Button, CircularProgress, SxProps, Theme, useTheme } from '@mui/material';

interface ActionButtonProps {
  text: string;
  loading?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  testId?: string;
  sx?: SxProps<Theme>;
  endIcon?: React.ReactNode;
  startIcon?: React.ReactNode;
  variant?: 'contained' | 'outlined' | 'text';
  color?: 'primary' | 'secondary' | 'inherit' | 'success' | 'error' | 'info' | 'warning';
  fullWidth?: boolean;
  type?: 'button' | 'submit' | 'reset';
  angle?: number;
  colors?: string[];
}

const ActionButton: React.FC<ActionButtonProps> = ({
  text,
  loading = false,
  disabled = false,
  onClick,
  testId,
  sx = {},
  endIcon,
  startIcon,
  variant = 'contained',
  color = 'secondary',
  fullWidth = true,
  type = 'button',
  angle = 90,
  colors
}) => {
  const theme = useTheme();
  const buttonColor = colors ?? [theme.palette.primary[400], theme.palette.primary.main];
  const background = (disabled || loading) ? `` : `linear-gradient(${angle}deg, ${buttonColor.join(", ")})`;
  const baseStyles: SxProps<Theme> = {
    mt: 1,
    background,
    '&:hover': {
      backgroundColor: '#2A2F42',
      boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
      transform: 'translateY(-1px)',
    },
    py: 1.5,
    borderRadius: 2.5,
    fontWeight: 600,
    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
  };
 
  return (
    <Button
      type={type}
      fullWidth={fullWidth}
      variant={variant}
      color={color}
      onClick={onClick}
      disabled={disabled || loading}
      data-testid={testId}
      startIcon={!loading && startIcon ? startIcon : undefined}
      endIcon={!loading && endIcon ? endIcon : undefined}
      sx={{
        ...baseStyles,
        ...sx,
      }}
    >
      {loading ? (
        <CircularProgress size={24} sx={{ color: 'white' }} />
      ) : (
        text
      )}
    </Button>
  );
};

export default React.memo(ActionButton);